import { Navbar } from '@/components';
import { useSidebarMenu } from '@/hooks';
import { useAuthStore } from '@/stores';
import { Sidebar, TooltipProvider, useSidebarCollapsed } from '@repo/ui';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ location }) => {
    if (!useAuthStore.getState().isAuthenticated) {
      throw redirect({
        to: '/',
        search: { redirect: location.href },
      });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const sidebar = useSidebarMenu();
  // Shared by the sidebar and the navbar's toggle; remembered under this storage key.
  const { collapsed, toggle } = useSidebarCollapsed('admin-sidebar');

  return (
    <TooltipProvider>
      <div className="flex h-screen w-full overflow-y-hidden">
        <Sidebar menuOptions={sidebar} collapsed={collapsed} />
        <div className="flex min-w-0 flex-1 flex-col">
          <Navbar sidebarCollapsed={collapsed} onToggleSidebar={toggle} />
          <div className="flex min-h-0 flex-1 flex-col overflow-y-auto px-2 py-6 sm:px-10 xl:px-6">
            <Outlet />
          </div>
        </div>
      </div>
    </TooltipProvider>
  );
}
